'use strict';

var colors = require('./chartsColors');
var highchartsTheme = require('./highchartsTheme')();
var truncateFormatter = function () {
  var MAX_LENGTH = 30;

  if (this.name.length > MAX_LENGTH) {
    return (this.name.slice(0, MAX_LENGTH)) + '\u2026';
  } else {
    return this.name;
  }
};

var defaults = {
  pie: {
    chart: {
      defaultSeriesType: 'pie'
    },
    colors: [
      colors.primaryDarker,
      colors.greySmoke,
      colors.grey,
      colors.greyMedium
    ],
    legend: {
      align: 'center',
      verticalAlign: 'middle',
      layout: 'vertical',
      margin: 0,
      floating: true,
      labelFormatter: function () {
        return this.name + '  ( ' + this.y + '% )';
      }
    },
    plotOptions: {
      pie: {
        states: {
          hover: {
            enabled: false
          }
        },
        allowPointSelect: false,
        cursor: 'default',
        shadow: false,
        borderColor: null,
        showInLegend: true,
        center: [38, 38],
        size: 96,
        dataLabels: {
          enabled: false
        }
      }
    }
  },
  line: {
    chart: {
      defaultSeriesType: 'spline',
      height: 250,
      marginRight: 0,
      marginLeft: 36,
      marginBottom: 80
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%e %b'
      },
      lineColor: colors.greySmoke,
      tickWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.05
    },
    yAxis: {
      gridLineWidth: 0,
      lineColor: null,
      lineWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.1,
      minRange: 0.01,
      endOnTick: false,
      min: 0,
      max: null,
      allowDecimals: false,
      labels: {
        x: -7,
        formatter: function () {
          var value = this.value;
          var sign = value < 0 ? '-' : '';

          value = Math.abs(value);

          if (value >= 1000 && value < 1000000) {
            value = Math.floor(value / 100) / 10;
            value += 'k';
          } else if (value >= 1000000) {
            value = Math.floor(value / 100000) / 10;
            value += 'M';
          }
          return sign + value;
        }
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      margin: 0,
      x: -18,
      labelFormatter: truncateFormatter
    },
    tooltip: {
      enabled: true
    },
    plotOptions: {
      spline: {
        groupPadding: 0,
        borderColor: null,
        stickyTracking: false,
        marker: {
          enabled: true,
          symbol: 'circle',
          radius: 2,
          states: {
            hover: {
              radius: 3
            }
          }
        },
        shadow: false,
        connectNulls: true
      }
    }
  },
  'gender-age-chart': {
    chart: {
      type: 'column',
      height: 250,
      marginBottom: 130
    },
    xAxis: {
      categories: ['13-17', '18-24', '25-34', '35-44', '45-54', '55-64', '65+'],
      lineWidth: 0,
      lineColor: colors.greySmoke,
      tickWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.05
    },
    yAxis: {
      lineColor: null,
      lineWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.1,
      endOnTick: false,
      labels: {
        formatter: function () {
          return Math.abs(this.value);
        }
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'bottom',
      floating: true,
      margin: 0,
      labelFormatter: truncateFormatter
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        var s = '<b>' + this.x + '</b>';

        $.each(this.points, function (i, point) {
          s += '<br/>' + point.series.name + ' : ' + Math.abs(point.y);
        });
        return s;
      },
      shared: true
    },
    plotOptions: {
      column: {
        stacking: 'normal',
        groupPadding: 0.15,
        pointWidth: 22,
        borderColor: null,
        shadow: false
      }
    }
  },
  column: {
    chart: {
      type: 'column',
      height: 250,
      marginRight: 0,
      marginLeft: 36,
      marginBottom: 20
    },
    xAxis: {
      type: 'datetime',
      dateTimeLabelFormats: {
        day: '%e %b'
      },
      lineColor: colors.greySmoke,
      tickWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.05
    },
    yAxis: {
      gridLineWidth: 0,
      lineColor: null,
      lineWidth: 0,
      minPadding: 0.05,
      maxPadding: 0.1,
      endOnTick: false,
      labels: {
        formatter: function () {
          var val = (this.value <= 0.01 ? 0 : this.value);
          var hours = Math.floor(val / 60);
          var minutes = Math.floor(val) % 60;
          var seconds = Math.floor((val - hours * 60 - minutes) * 60);

          if (hours > 0) {
            return hours + 'h';
          } else if (minutes > 0) {
            return minutes + 'm';
          } else if (seconds > 0) {
            return seconds + 's';
          } else {
            return val;
          }
        }
      }
    },
    legend: {
      align: 'left',
      verticalAlign: 'top',
      margin: 0,
      floating: true,
      x: 36,
      labelFormatter: truncateFormatter
    },
    tooltip: {
      enabled: true,
      formatter: function () {
        var label = '';
        var val = (this.y <= 0.01 ? 0 : this.y);
        var hours = Math.floor(val / 60);
        var minutes = Math.floor(val) % 60;
        var seconds = Math.floor((val - hours * 60 - minutes) * 60);

        label += (hours > 0 ? ' ' + hours + 'h' : '');
        label += (minutes > 0 ? ' ' + minutes + 'm' : '');
        label += (seconds > 0 ? ' ' + seconds + 's' : '');

        if (label.length === 0) {
          label = '0';
        }
        return '' + window.Highcharts.dateFormat('%e. %b %Y', this.x) + ' : ' + label;
      }
    },
    plotOptions: {
      column: {
        borderWidth: 0,
        shadow: false,
        color: colors.error
      }
    }
  }
};

window.Highcharts.theme = highchartsTheme;
window.Highcharts.setOptions(highchartsTheme);

// update charts setting for avoid bugs in pdf generation
if ($('body').hasClass('pdf')) {
  defaults.line.plotOptions.spline.enableMouseTracking = false;
  defaults.line.plotOptions.spline.animation = false;
  defaults.line.plotOptions.spline.shadow = false;
}

window.buildChartConfig = function (type, overwrites) {
  return $.extend(true, {}, defaults[type], overwrites);
};
